import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';
import styled from 'styled-components/native';

export const SwiperHeader = styled.View`
  width: 50px;
  height: 5px;
  border-radius: ${metrics.borderRadius}px;
  background-color: ${AppColors.border};
  align-self: center;
  margin-bottom: ${metrics.medium}px;
`;
